import { render, staticRenderFns } from "./SelectQuestions.vue?vue&type=template&id=08e551df&"
import script from "./SelectQuestions.vue?vue&type=script&lang=js&"
export * from "./SelectQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports